<app-navbar></app-navbar>

<section class="py-20 md:py-24 xl:py-32 min-h-[50dvh] bg-bl text-white bg-black">
    <div class="container mx-auto px-4 text-center">
        <div>
            <h1 class="text-3xl text-green-500 mb-4 uppercase">{{texts.title}}</h1>
            <p>{{texts.subtitle[0]}}</p>
            <p class="text-green-500 font-bold">{{texts.subtitle[1]}}</p>
            <p>{{texts.subtitle[2]}}</p>
        </div>
        <div class="mt-10">
            <h2 class="text-2xl uppercase">{{texts.next_steps_text}}</h2>
            <div class="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-4xl mx-auto text-left">
                <div>
                    <label for="company" class="block mb-2 font-semibold">{{texts.company.title}}</label>
                    <input type="text" id="company" name="company" class="w-full px-4 py-2 rounded bg-white text-black border
                     border-gray-600 focus:outline-none focus:border-green-500" [placeholder]="texts.company.placeholder" required>
                </div>
                
                <div>
                    <label for="name" class="block mb-2 font-semibold">{{texts.name.title}}</label>
                    <input type="text" id="name" name="name" class="w-full px-4 py-2 rounded bg-white text-black border
                     border-gray-600 focus:outline-none focus:border-green-500" [placeholder]="texts.name.placeholder" required>
                </div>
                <div>
                    <label for="address" class="block mb-2 font-semibold">{{texts.address.title}}</label>
                    <input type="text" id="address" name="address" class="w-full px-4 py-2 rounded bg-white text-black border 
                    border-gray-600 focus:outline-none focus:border-green-500" [placeholder]="texts.address.placeholder" required>
                </div>
                <div>
                    <label for="phone" class="block mb-2 font-semibold">{{texts.phonenumber.title}}</label>
                    <input type="tel" id="phone" name="phone" class="w-full px-4 py-2 rounded bg-white text-black border 
                    border-gray-600 focus:outline-none focus:border-green-500" [placeholder]="texts.phonenumber.placeholder" required>
                </div>
                <div>
                    <label for="email" class="block mb-2 font-semibold">{{texts.email.title}}</label>
                    <input type="email" id="email" name="email" class="w-full px-4 py-2 rounded bg-white text-black border 
                    border-gray-600 focus:outline-none focus:border-green-500" [placeholder]="texts.email.placeholder" required>
                </div>
                <div>
                    <label for="website" class="block mb-2 font-semibold">{{texts.website.title}}</label>
                    <input type="url" id="website" name="website" class="w-full px-4 py-2 rounded bg-white text-black border 
                    border-gray-600 focus:outline-none focus:border-green-500" [placeholder]="texts.website.placeholder">
                </div>
                <div class="md:col-span-3">
                    <label for="comments" class="block mb-2 font-semibold">{{texts.comments.title}}</label>
                    <textarea id="comments" name="comments" class="w-full h-48 px-4 py-2 rounded bg-white text-black border 
                    border-gray-600 focus:outline-none focus:border-green-500" [placeholder]="texts.comments.placeholder" required></textarea>
                </div>
                <div class="md:col-span-3 flex justify-center mt-4">
                    <button type="submit" class="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-8 rounded transition-colors duration-200 text-2xl">
                        {{texts.send_btn.title}}
                    </button>
                </div>

                
            </div>
        </div>
        
    </div>
</section>


<app-footer></app-footer>

